/**
 * Radar de couverture FairView d'UN candidat, contre le barème de son
 * template. Rendu sous le classement de l'onglet Matching de la campagne, et
 * dans la fiche candidat (FairView › Matching).
 */
import { useMemo } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@repo/ui";
import { EntStructMatchingChart } from "@repo/results";
import type { EntreeClassementEntStruct } from "./useClassementEntStruct";

export function RestitutionMatchingEntStruct({
  entree: selection,
}: {
  entree: EntreeClassementEntStruct;
}) {
  const poidsMax = useMemo(
    () => selection.lignes.reduce((m, l) => Math.max(m, l.poids), 0),
    [selection],
  );

  return (
    <>
      {/* Radar du candidat sélectionné. */}
      {selection.lignes.length > 0 && (
        <Card>
          <CardHeader className="pb-0">
            <CardTitle className="text-base">
              {selection.evaluation.prenomCandidat}{" "}
              {selection.evaluation.nomCandidat}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <EntStructMatchingChart lignes={selection.lignes} />
            {/* Légende de l'intensité : la couleur porte le poids, elle ne doit
                jamais être le seul canal — les poids exacts sont aussi dans
                l'infobulle de chaque compétence. */}
            <div className="text-muted-foreground flex flex-wrap items-center justify-center gap-3 text-xs">
              <span>Intensité du fond = poids de la compétence :</span>
              <span className="flex items-center gap-1.5">
                <span
                  className="bg-primary h-3 w-6 rounded-sm"
                  style={{ opacity: 0.08 }}
                />
                faible
              </span>
              <span className="flex items-center gap-1.5">
                <span
                  className="bg-primary h-3 w-6 rounded-sm"
                  style={{ opacity: 0.55 }}
                />
                {poidsMax > 0
                  ? `le plus lourd du barème (${Math.round(poidsMax * 10) / 10})`
                  : "le plus lourd du barème"}
              </span>
              <span>
                La distance au centre est la couverture, jamais le poids.
              </span>
            </div>
          </CardContent>
        </Card>
      )}
    </>
  );
}
